import * as React from 'react';
import type { Product } from '@/types';
import { Link } from '@tanstack/react-router';
import {StoreLogo} from "@/web/components/molecules/StoreLogo.tsx";

export interface ProductCardProps {
  product: Product;
}

const getProductImage = (product: Product): React.ReactElement | null => {
  if (product.imageUrls.length) {
    return (<img src={product.imageUrls[0]} />);
  }
  return null;
}

const convertCentsToDollars = (cents: number): string => {
  return (cents / 100).toFixed(2);
}

const showComparativePricing = (product: Product): React.ReactElement | null => {
  if (product.price && product.price.comparativePricing) {
    return (
      <h3 className="mt-2">${convertCentsToDollars(product.price.comparativePricing.priceAsCents)} per {product.price.comparativePricing.quantity}{product.price.comparativePricing.unitOfMeasure}</h3>
    )
  }
  return null;
}

export function ProductCard(props: ProductCardProps) {
  return (<div className="product-card flex flex-col">
    <div className="flex gap-4">
      <div className="product-image">
        {getProductImage(props.product)}
      </div>
      <div className="product-details">
        <div className="product-brand">{props.product.brand}</div>
        <Link
            to="/products/$categoryId/details/$productId"
            params={{
              categoryId: props.product.categories.level0,
              productId: props.product.productId,
            }}
            className="text-lg font-semibold hover:underline cursor-pointer text-blue-600"
        >
          {props.product.name}
        </Link>
        <h1 className="text-xl font-bold mt-2">${convertCentsToDollars(props.product.price.amountAsCents)}</h1>
        {showComparativePricing(props.product)}
        <div className="product-id">{props.product.productId}</div>
      </div>
    </div>
    <div className="flex gap-4">
      <StoreLogo product={props.product} />
    </div>

  </div>)
}
